import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";

headerStyles.totalText = mergeToNew(headerStyles.totalText, {
    color: "text.accent",
});
